import { useAuth } from "./auth";
import roleAndPrivilegesFnc from "../utils/roleAndPriviledges";
function useIsRoleName () {
    const auth = useAuth();
    if(auth){
        const {roleData}=roleAndPrivilegesFnc(auth?.cookies?.token);
        return  roleData;
    }
   
}

export default useIsRoleName;